import type { IApiResponse, AbonementInfoSerializer } from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";
import { standardRetryingRequestOptions } from "../api/retrying";

export const abonementApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getUserAbonementInfo: build.query<AbonementInfoSerializer, null>({
      query: () => ({
        url: `/foundation/api/users/me/abonement/detailed`,
      }),
      transformResponse: (response: IApiResponse<AbonementInfoSerializer>) =>
        response.payload.data,
      extraOptions: {
        ...standardRetryingRequestOptions,
      },
    }),
  }),
});
